export default __webpack_public_path__ + "static/media/Flag_of_Isle_of_Man.3ae00571.svg";